import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgPaymentSucceeded(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M26.745 49.773c1.027 3.834-.73 7.637-3.925 8.493-3.195.856-6.618-1.558-7.646-5.392-1.027-3.834.73-7.637 3.925-8.493 3.195-.856 6.618 1.558 7.646 5.392Z"
        fill="#FC0"
      />
      <path
        d="M15.174 52.874c1.027 3.834 4.45 6.248 7.646 5.392l-2.315.62c-3.195.856-6.617-1.558-7.645-5.392-1.027-3.834.73-7.636 3.925-8.492l2.314-.62c-3.195.856-4.952 4.658-3.925 8.492Z"
        fill="#E67500"
      />
      <path
        d="M93.95 68.612c-2.806 2.807-3.944 6.22-2.54 7.623 1.403 1.404 4.816.266 7.622-2.54 2.807-2.807 3.945-6.22 2.541-7.624-1.403-1.403-4.816-.265-7.623 2.541Z"
        fill="#FC0"
      />
      <path
        d="M99.032 73.694c-2.806 2.807-6.22 3.944-7.623 2.541l1.694 1.694c1.404 1.403 4.817.266 7.623-2.54 2.807-2.808 3.945-6.22 2.541-7.624l-1.694-1.694c1.404 1.404.266 4.816-2.54 7.623Z"
        fill="#E67500"
      />
      <path
        d="M78.913 22.25H25.045a7.696 7.696 0 0 0-7.696 7.695h53.869a7.696 7.696 0 0 1 7.695-7.695Z"
        fill="#CCD5E1"
      />
      <path d="M86.609 84.584V37.64l-53.868-7.695v46.942l53.868 7.696Z" fill="#fff" />
      <path
        d="M32.74 91.51a7.696 7.696 0 0 0 7.696 7.695h53.869a7.696 7.696 0 0 1-7.696-7.695V29.945a7.696 7.696 0 0 0-7.695-7.695h-53.87a7.696 7.696 0 0 1 7.696 7.695V91.51Z"
        fill="#F1F5F9"
      />
      <path
        d="M73.431 74.752c0-.383-.064-.752-.179-1.098l-2.73 2.732a.8.8 0 0 1-1.132 0l-1.068-1.069a.8.8 0 0 1 1.13-1.131l.504.503 2.425-2.426a3.476 3.476 0 1 0 1.05 2.49Zm1.6 0a5.075 5.075 0 1 1-1.519-3.62l1.222-1.22a.8.8 0 0 1 1.132 1.13l-1.395 1.394c.357.694.56 1.481.56 2.316Z"
        fill="#78B441"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.484 70.672a.667.667 0 0 1 .944 0l2.865 2.865 2.866-2.865a.667.667 0 1 1 .944.944l-2.866 2.866 2.866 2.865a.667.667 0 1 1-.944.944l-2.866-2.865-2.865 2.865a.667.667 0 1 1-.944-.944l2.865-2.865-2.865-2.866a.667.667 0 0 1 0-.944Z"
        fill="#B3C0D0"
      />
      <path
        d="M50.805 70.32a1.166 1.166 0 0 1 1.65 0l.001-.001a1.167 1.167 0 0 1 0 1.65l-2.512 2.513 2.512 2.512a1.167 1.167 0 1 1-1.651 1.65l-2.512-2.511-2.511 2.512a1.168 1.168 0 0 1-1.652-1.65l2.512-2.513-2.512-2.513a1.167 1.167 0 0 1 0-1.65h.001a1.165 1.165 0 0 1 1.65 0l2.512 2.511 2.512-2.51Zm.944.706a.167.167 0 0 0-.236 0l-3.22 3.218-3.218-3.218a.168.168 0 0 0-.238 0 .167.167 0 0 0 0 .236l3.219 3.22-3.219 3.22a.168.168 0 0 0 .237.236l3.22-3.219 3.218 3.219a.169.169 0 0 0 .237 0 .167.167 0 0 0 0-.237l-3.218-3.22 3.218-3.22a.167.167 0 0 0 0-.235Z"
        fill="#B3C0D0"
      />
      <path
        d="M40.436 99.205h53.868A7.696 7.696 0 0 0 102 91.51H48.131a7.696 7.696 0 0 1-7.695 7.695Z"
        fill="#CCD5E1"
      />
      <path
        d="M47.331 91.51a.8.8 0 0 1 1.6 0 8.495 8.495 0 0 1-8.495 8.495.8.8 0 0 1 0-1.6 6.895 6.895 0 0 0 6.895-6.895Z"
        fill="#0F172A"
      />
      <path
        d="M77.575 39.724a.8.8 0 0 0 0-1.6H41.662a.8.8 0 0 0 0 1.6h35.913Zm0 7.695a.8.8 0 0 0 0-1.6H41.662a.8.8 0 0 0 0 1.6h35.913Zm0 7.696a.8.8 0 0 0 0-1.6H41.662a.8.8 0 1 0 0 1.6h35.913Zm0 7.695a.8.8 0 1 0 0-1.6H41.662a.8.8 0 1 0 0 1.6h35.913Z"
        fill="#B3C0D0"
      />
      <path
        d="M31.733 43.625V29.794c0-3.731-2.998-6.744-6.682-6.744a.8.8 0 1 1 0-1.6c4.58 0 8.281 3.742 8.281 8.344v13.831a.8.8 0 0 1-1.6 0Z"
        fill="#0F172A"
      />
      <path
        d="M64.183 21.99a2.523 2.523 0 0 1 3.09-1.785l38.992 10.448a2.523 2.523 0 0 1 1.784 3.09l-6.53 24.37a2.522 2.522 0 0 1-3.09 1.784L59.437 49.45a2.523 2.523 0 0 1-1.784-3.09l6.53-24.37Z"
        fill="#78B441"
      />
      <path
        d="m76.558 43.066-10.236-2.742a.757.757 0 0 0-.391 1.462l10.235 2.743a.757.757 0 1 0 .392-1.463Z"
        fill="#00664F"
      />
      <path d="M107.135 37.155 63.269 25.4 61.7 31.25l43.866 11.754 1.568-5.85Z" fill="#0F172A" />
      <path
        d="m72.85 45.207-7.311-1.959a.757.757 0 1 0-.392 1.463l7.311 1.958a.757.757 0 0 0 .392-1.462Z"
        fill="#00664F"
      />
      <path
        d="M89.861 48.982a2.27 2.27 0 1 1 4.387 1.175 2.27 2.27 0 0 1-4.387-1.175Z"
        fill="#007A5F"
      />
      <path
        d="M92.786 49.765a2.27 2.27 0 1 1 4.386 1.176 2.27 2.27 0 0 1-4.386-1.176Z"
        fill="#599F40"
      />
    </svg>
  )
}
export default wrapIllustration(SvgPaymentSucceeded)
